import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50dc4f77")

_pushScopeId("data-v-50dc4f77")
const _hoisted_1 = { class: "CompletedCalendar" }
const _hoisted_2 = { class: "CompletedCalendar__header" }
const _hoisted_3 = {
  key: 0,
  class: "header__title"
}
const _hoisted_4 = {
  key: 1,
  class: "header__title"
}
const _hoisted_5 = { class: "CompletedCalendar__body" }
const _hoisted_6 = { class: "body__row" }
const _hoisted_7 = { class: "body__col" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "col__subtext" }, "Дата отправки", -1)
const _hoisted_9 = { class: "col__text" }
const _hoisted_10 = { class: "body__row" }
const _hoisted_11 = { class: "body__col" }
const _hoisted_12 = {
  key: 0,
  class: "col__subtext"
}
const _hoisted_13 = {
  key: 1,
  class: "col__subtext"
}
const _hoisted_14 = {
  key: 2,
  class: "col__text"
}
const _hoisted_15 = {
  key: 3,
  class: "col__text"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_calendar = _resolveComponent("icon-calendar")!
  const _component_icon_clock = _resolveComponent("icon-clock")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (Boolean(_ctx.sendTime))
        ? (_openBlock(), _createBlock("h2", _hoisted_3, "Дата и время"))
        : _createCommentVNode("", true),
      (Boolean(_ctx.sendPeriod))
        ? (_openBlock(), _createBlock("h2", _hoisted_4, "Дата и период"))
        : _createCommentVNode("", true),
      (!_ctx.blocked)
        ? (_openBlock(), _createBlock(_component_icon_edit, {
            key: 2,
            class: "header__edit",
            onClick: _ctx.emitReset
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_icon_calendar, { class: "row__icon" }),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode("p", _hoisted_9, _toDisplayString(_ctx.sendDate), 1)
        ])
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_icon_clock, { class: "row__icon" }),
        _createVNode("div", _hoisted_11, [
          (Boolean(_ctx.sendTime))
            ? (_openBlock(), _createBlock("p", _hoisted_12, "Время отправки"))
            : _createCommentVNode("", true),
          (Boolean(_ctx.sendPeriod))
            ? (_openBlock(), _createBlock("p", _hoisted_13, "Период отправки"))
            : _createCommentVNode("", true),
          (Boolean(_ctx.sendTime))
            ? (_openBlock(), _createBlock("p", _hoisted_14, _toDisplayString(_ctx.sendTime), 1))
            : _createCommentVNode("", true),
          (Boolean(_ctx.sendPeriod))
            ? (_openBlock(), _createBlock("p", _hoisted_15, _toDisplayString(_ctx.sendPeriod.name || _ctx.sendPeriod), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})